import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7efy71k58i: FaireBrandEntity = {
  token: "b_7efy71k58i",
  type: "brand",
  name: "Keracolor",
  avatarUrl:
    "https://cdn.faire.com/fastly/87109e5f3f5fec508a1839d36683becc1fb418b4fa79567a32dc825044c3af1e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/422d0a00c08e9bb9ae29bbc615a3f6294b4630e086becc109a926b9fb895746d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/87109e5f3f5fec508a1839d36683becc1fb418b4fa79567a32dc825044c3af1e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/422d0a00c08e9bb9ae29bbc615a3f6294b4630e086becc109a926b9fb895746d.jpeg",
  location: "Eagan, MN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Keracolor is the new vision for hair color, devoted to protecting the beauty and your hair's overall health and wellness. The Keracolor line is infused with our signature Keratin that intensely conditions, strengthens, smooths, and nourishes your hair with each use. Our Color + Clenditioners are a non-lather conditioning cleanser that deposits color while gently cleansing the hair. Twenty-one various shades cater to different hair colors and can be used to enhance the existing color or experiment with new temporary shades. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:48.322Z",
    importedBy: "entity-db-cli",
  },
};
